<style lang="scss" scoped>
@import "$vars";
label, span  {
  strong {
    display: block;
    margin-bottom: 10px !important
  }
  margin-bottom: 20px
}
.chip {
  // background: transparent;
  // border: 1px solid #e1e1e1;
  // color: $color-blue
  background: $color-blue;
  display: block;
  font-size: 0.65rem;
  font-weight: 600;
  max-width: 100%;
  padding: 0.4rem;
  width: auto;
}
.chips {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 0;
  margin-right: 0;
}

h5 {
  color: #4a4a4a;
  font-family: $base-font-family;
  font-size: 18px;
  font-weight: 600;
}
.toast-warning {
  background: #fcf8e3;
  color: #94794a;
  border-color: #f5f3e0;
  margin-bottom: 10px;
  p {
    margin: 0
  }
}

.files-list {
  flex-wrap: wrap;
  width: 100%;

  div {
    font-size: 0.65rem;
    font-weight: 600;
  }

  span {
    font-size: 0.6rem;
  }
}

.files {
  @apply px-2;
  flex: 0 0 calc((100% - 1rem) / 4);
  margin: 0 0 1.75rem 0;

  &__digital-signature {
    @apply max-w-full rounded-sm text-white cursor-default block font-semibold text-xs my-0 mx-auto #{!important};
    background: rgb(6, 100, 191);
    padding: 0.125rem 0.3rem;
    width: max-content;
  }
}

.modal-footer {
  span {
    display: flex;
    width: max-content;
  }
}

.error {
  box-shadow: 0 0 0 0.1rem rgba(248, 83, 89, 0.2);
  border-bottom: 1px solid rgb(248, 83, 89);
  border-color: rgb(248, 83, 89);
}
</style>

<template>
  <main class="component-patients" v-if="loaded">
    <printTemplate
      :active.sync="modalActive"
      :formData="formData"
      :patient="patient"
      :type="'exam'"
      @cancel="modalActive = null"
      v-if="modalActive != null" />
    <form class="columns" @submit.prevent="submit()">
      <label class="column col-8">
        <strong>Exame</strong>
        <!-- <select :disabled="!appointmentStarted" class="form-select" v-model="formData.medicalService" id="">
          <option v-for="service in medicalServices" :value="service.id" :key="'service_' + service.id">{{service.name}}</option>
        </select> -->
        <dr-autocomplete
          :ref="'autocomplete_blank'"
          :endpoint="`medical_service`"
          :defaultFilter="`uf=${this.patient.address || 'SP'}`"
          :newFilter="true"
          :format="'{$name}'"
          :fields="['filterAndLike[ms.name]']"
          :return-format="'{$id}'"
          placeholder="Busque pelo nome do exame"
          :store-type="'exam'"
          :class="{ 'error': isMedicalServiceDirty }"
          @change="formData.medicalService = $event"
          @isEmpty="$event > 0 ? newExam = true : newExam = false; newExamToast = true"
          @typed="autocompleteValue = $event; newExamToast = false"
          >
        </dr-autocomplete>
      </label>
      <label class="column col-4">
        <strong>Data</strong>
        <div class="has-icon-right">
          <input disabled class="form-input" :value="$moment().format('YYYY-MM-DD')" />
          <dr-icon class="form-icon" fill="blue" name="dashCalendar"></dr-icon>
        </div>
      </label>
      <transition name="fade">
        <div v-if="newExam" class="col-8">
          <div class="toast toast-warning" v-if="newExamToast">
            <p>
              <a class="btn btn-clear float-right" @click="newExamToast = false"></a>
              <small>
                <b>Atenção!</b> Este exame não consta em nosso banco de dados. Você precisará cadastrá-lo para fazer o pedido.
              </small>
            </p>
          </div>
          <button type="button" @click="createExam()" :disabled="newExamSending" class="btn btn-sm btn-primary">Cadastrar novo exame</button>
          <br /><br />
        </div>
      </transition>

      <label
        v-if="mostRequested.length > 0"
        class="column col-12"
      >
        <strong>
          Exames mais pedidos
        </strong>

        <ul class="chips">
          <li
            v-for="exam in mostRequested.slice(0, 5)"
            :key="'exam_' + exam.medicalServiceId"
            :disabled="!appointmentStarted"
            class="chip clickable"
            @click="requestMost(exam)"
          >
            {{ exam.medicalServiceName }}
          </li>
        </ul>
      </label>

      <span class="column col-12">
        <strong>Detalhes do exame</strong>
        <ckeditor :disabled="!appointmentStarted" :editor="editor" @ready="onReady" v-model="formData.note" :config="editorConfig"></ckeditor>
      </span>
      <footer>
        <dr-submit :disabled="!isFormValid()" class="btn-sm" text="Salvar" :sending="sending"></dr-submit>
        <!-- <button :disabled="!isFormValid()" class="btn btn-sm btn-default"><dr-icon style="width: 20px" name="imprimir" fill="white"></dr-icon>Imprimir</button> -->
      </footer>
    </form>

    <file-history
      v-if="isActiveAppointment"
      type="exam"
      :appointment-id="appointment.id"
      :is-active-appointment="isActiveAppointment"
      :is-medical-history-visible="isMedicalHistoryVisible.status"
      :appointment-date="appointment['appointment_start']"
    />
  </main>
</template>

<script>
import drSubmit from '@/components/form/submit'
import drAutocomplete from '@/components/form/autocomplete'
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/pt-br.js'
import CKEditor from '@ckeditor/ckeditor5-vue'
import DocumentEditor from '@ckeditor/ckeditor5-build-decoupled-document/build/ckeditor.js'
import printTemplate from '@/components/templates/print/'
import FileHistory from '@/components/layout/appointments/fileHistory'
import EventBus from '@/globals/eventBus'

export default {
  props: {
    patient: {
      required: false
    },

    appointment: {
      required: false
    },

    appointmentStarted: {
      required: false
    },

    isMedicalHistoryVisible: {
      required: false
    },

    isHistory: {
      default: () => false
    }
  },

  components: {
    ckeditor: CKEditor.component,
    drSubmit,
    drAutocomplete,
    printTemplate,
    FileHistory
  },

  data () {
    return {
      loaded: false,
      exams: [],
      newExam: false,
      newExamToast: false,
      newExamSending: false,
      autocompleteValue: null,
      sending: false,
      send: false,
      modalActive: null,
      editor: DocumentEditor,
      medicalServices: [],
      mostRequested: [],
      formData: {
        agenda: this.appointment.id,
        medicalService: null,
        note: ''
      },
      isMedicalServiceDirty: false,
      editorConfig: {
        language: 'pt-br',
        removePlugins: [ 'Heading', 'Link' ],
        toolbar: ['bold', 'italic', 'strikethrough', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo']
      },
      currentDocument: null,
      modalType: null
    }
  },

  computed: {
    appointmentExams () {
      const todayExams = []
      const currentAppointment = this.$store.getters.getActiveAppointments
      this.exams.forEach((exam) => {
        currentAppointment.forEach((appointment) => {
          if (appointment.id === exam.agenda.id) {
            todayExams.push(exam)
          }
        })
      })
      return todayExams
    },

    'formData.medicalService': {
      deep: false,
      immediate: false,
      handler (value) {
        if (!value) {
          this.isMedicalServiceDirty = true
          return
        }

        this.isMedicalServiceDirty = false
      }
    },

    isActiveAppointment () {
      if (
        this.$store.getters.getActiveAppointments.length > 0 &&
        this.$store.getters.getActiveAppointments[0].id === this.$attrs['agenda_id']
      ) {
        return true
      }

      return false
    }
  },

  created () {
    EventBus.$on('submit-exams', (args) => {
      if (this.isFormValid()) {
        this.submit(args)
        return
      }

      this.$store.dispatch('setModalAlert', {
        title: 'Atenção',
        body: 'Este formulário contém dados inválidos e não foi possível salvá-lo.',
        size: 'md',
        active: true
      })
    })
  },

  mounted () {
    this.fetch()

    this.$http
      .get('/doctor/exam_request/most_requested', this.$store.getters.getAuthHeader)
      .then((res) => {
        this.mostRequested = res.data
      })

    this.$http.get(`/medical_service?uf=${this.patient.address || 'SP'}`, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.medicalServices = res.data.data
      }
    ).catch(
      (err) => {
        console.log(err)
      }
    )
  },

  methods: {
    isToday (exam) {
      if (this.$moment(exam.created_at).format('DD/MM/YYYY') === this.$moment(new Date()).format('DD/MM/YYYY')) {
        return true
      }
    },
    isFormValid () {
      return this.formData.medicalService
    },
    checkFields () {
      for (let field in this.formData) {
        if (!this.formData[field]) {
          return true
        }
      }
    },
    fetch () {
      this.fn_SHOW_PROGRESS()
      this.$http.get(`/exam_request?order[er.createdAt]=DESC&itensPerPage=50&filterAnd[${this.$route.params.patientType === 'patient' ? 'u' : 'sp'}.id]=${this.patient.id}`, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.loaded = true
          this.exams = res.data.data
          this.fn_HIDE_PROGRESS()
        }
      )
    },
    requestMost (exam) {
      this.formData.medicalService = exam.medicalServiceId
      this.$refs.autocomplete_blank.inputValue = {
        name: exam.medicalServiceName,
        id: exam.id
      }
      this.$refs.autocomplete_blank.searchTerm = exam.medicalServiceName
    },
    createExam () {
      if (this.autocompleteValue.length === 0) {
        return
      }

      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: `Confirma a criação do exame "${this.autocompleteValue}"?`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (!v) {
            this.$store.dispatch('setModalConfirm')
          } else {
            this.newExamSending = true
            this.fn_SHOW_PROGRESS()
            this.$http
              .post(
                `/doctor/medical_service`,
                {
                  medical_service: {
                    name: this.autocompleteValue
                  }
                },
                this.$store.getters.getAuthHeader
              ).then((res) => {
                this.formData.medicalService = res.data
                this.newExam = false
                this.newExamToast = false
                this.newExamSending = false
                this.$store.dispatch('setModalConfirm')
                this.fn_HIDE_PROGRESS()
              })
              .finally(() => {
                EventBus.$emit('reload-file-history')
              })
          }
        },
        size: 'md',
        active: true
      })
    },
    removeExam (id) {
      const self = this
      this.$store.dispatch('setModalConfirm', {
        title: 'Confirmação',
        body: `Tem certeza que deseja apagar o exame?`,
        confirmText: 'Confirmar',
        cancelText: 'Cancelar',
        beforeClose (v) {
          if (!v) {
            this.$store.dispatch('setModalConfirm')
          } else {
            this.fn_SHOW_PROGRESS()
            this.$http.delete(`exam_request/${id}`, this.$store.getters.getAuthHeader).then(
              (res) => {
                self.$emit('success', true)
                this.$store.dispatch('setModalConfirm')
                this.$store.dispatch('setModalAlert', {
                  title: 'Sucesso',
                  body: 'Exame removido com sucesso',
                  size: 'md',
                  active: true
                })
                self.fetch()
                self.fn_HIDE_PROGRESS()
                setTimeout(() => {
                  this.$store.dispatch('setModalAlert', {
                    active: false
                  })
                }, 2000)
              }
            )
          }
        },
        size: 'md',
        active: true
      })
    },

    submit ({ showConfirmation = true, nextSection = null, nextTab = null } = {}) {
      this.sending = true
      this.fn_SHOW_PROGRESS()
      // delete this.formData.note
      EventBus.$emit('appointment-start-saving')

      this.$http
        .post(
          `/exam_request`,
          { exam_request: this.formData },
          this.$store.getters.getAuthHeader
        )
        .then((res) => {
          const msg = !this.isActiveAppointment
            ? `Seu exame foi gerado com sucesso${
              this.patient.email ? ` e será enviado para o e-mail do paciente (<b>${this.patient.email}</b>).` : '.'
            } Caso você tenha certificado de assinatura digital, levará alguns minutos para que o documento seja assinado digitalmente.`
            : 'Exame salvo com sucesso'

          if (showConfirmation) {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: msg,
              size: 'md',
              active: true
            })

            if (this.isActiveAppointment) {
              setTimeout(() => {
                this.$store.dispatch('setModalAlert', {
                  active: false
                })
              }, 2000)
            }
          }
          // this.formData.expirationDate = 'null' ?
          this.formData.medicalService = null
          this.$refs.autocomplete_blank.searchTerm = ''
          this.$refs.autocomplete_blank.resetValues()
          this.formData.note = ''
          this.sent = true
          this.sending = false
          this.fetch()
          this.fn_HIDE_PROGRESS()

          if (nextSection) EventBus.$emit('consultation-change-section', nextSection)
          if (nextTab) EventBus.$emit('consultation-change-tab', nextTab)
        })
        .catch((err) => {
          console.log(err)
          this.sending = false
          this.fn_HIDE_PROGRESS()
        })
        .finally(() => {
          EventBus.$emit('appointment-stop-saving')
          EventBus.$emit('reload-file-history')
        })
    },
    onReady (editor) {
      editor.ui.view.editable.element.parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.view.editable.element
      )
    },

    openExam (exam) {
      if (('signed_file' in exam) && exam['signed_file']) {
        const url = `${process.env.ROOT_API}/s3/file/exam_request/${exam['id']}/signed_file`
        this.$http
          .get(
            url,
            {
              headers: this.$store.getters.getAuthHeader.headers,
              responseType: 'blob'
            }
          )
          .then(res => this.generatePDFFile(res.data))
          .then(objURL => this.embedFile(objURL))
          .then((embed) => {
            if (embed) {
              this.currentDocument = 'Pedido de exame'
              this.modalType = 'document'
            }
          })
          .catch(err => console.trace(err))
      } else {
        this.modalActive = exam
      }
    },

    generatePDFFile (rawData) {
      const blob = new Blob([rawData], { type: 'application/pdf' })
      return URL.createObjectURL(blob)
    },

    embedFile (file = null) {
      if (file) {
        const wrapper = document.querySelector('#pdf__container')
        const embed = document.createElement('embed')
        embed.classList.add('pdf-file')
        embed.style.height = '70vh'
        embed.style.width = '100%'
        embed.setAttribute('src', file)
        wrapper.appendChild(embed)

        return true
      }

      return false
    },

    removeEmbed () {
      const wrapper = document.querySelector('#pdf__container')
      const embed = wrapper.querySelectorAll('embed')
      for (let el of embed) {
        el.remove()
      }
      this.modalType = null
      this.currentDocument = null
    },

    hasUnsavedData () {
      if (!this.formData.medicalService) {
        this.isMedicalServiceDirty = true
      }

      if (
        (this.formData.medicalService !== null && this.formData.medicalService !== '') ||
        (this.formData.note !== null && this.formData.note !== '')
      ) {
        return true
      }

      return false
    }
  }
}
</script>
